import { ClientEntity } from "@/property/shared/entities/ClientEntity";

export class ClientModel {
  public static from(client?: ClientEntity) {
    return new ClientModel(client?.id, client?.name);
  }

  public constructor(public id?: number, public name?: string) {}
}
